import { Log, UserManager } from 'oidc-client-ts';

import { configureEnv } from '../../env';

export const handleLoginRedirect = () => {
    const runsInIframe = window?.parent && window.parent !== window;
    const { runtimeConfig } = configureEnv(window, import.meta.env);

    if (runsInIframe) {
        // Silent redirect within an <iframe>
        Log.setLogger(console);
        Log.setLevel(Log.INFO);

        // This will propagate the received information provided via
        // query parameters to the parent frame
        void new UserManager({
            authority: `${runtimeConfig.login.authority}`,
            client_id: `${runtimeConfig.login.clientId}`,
            redirect_uri: `${runtimeConfig.login.redirectUri}`,
            silent_redirect_uri: `${runtimeConfig.login.silentRedirectUri || runtimeConfig.login.redirectUri}`,
            response_type: 'code',
        })
            .signinSilentCallback()
            .catch(error => {
                // eslint-disable-next-line no-console
                console.error('[oidcLogin] signinSilentCallback failed', error);
            });

        return;
    }

    window.location.replace(`${window.location.origin}#/?${window.location.hash.replace('#', '')}`);
};
